import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout.js";
import { AuthProvider } from "./pages/login/AuthProvider";
import AdminPrivateRoute from "./components/AdminPrivateRoute";
import { PaymentProvider } from "./components/PaymentContext";
import ScrollToTop from "./components/ScrollToTop";
import "./components/btHolidayCopy";
// 前台路由
import Home from "./pages/home";
import Newdetail from "./pages/home/newdetail";
import Origin from "./pages/about/origin";
import Glory from "./pages/about/glory";
import Csr from "./pages/about/csr";
import Becker from "./pages/becker";
import Quickbuy from "./pages/quickbuy";
import Cpa from "./pages/cpa";
import Cia from "./pages/cia";
import Cpe from "./pages/cpe";
import Cma from "./pages/cma";
import Ea from "./pages/ea";
import Csu from "./pages/csu";
import Registration from "./pages/registration";
import Plan from "./pages/registration/plan";
import Payinfo from "./pages/registration/payinfo";
import Pay from "./pages/registration/pay";
import Success from "./pages/registration/success";
import Failed from "./pages/registration/failed";
import Share from "./pages/share";
import Detail from "./pages/share/detail";
import Service from "./pages/service";
import Video from "./pages/video";
import Faq from "./pages/faq";
import Contact from "./pages/contact";
import Consult from "./pages/consult";
import Form from "./pages/consult/form";
import Audition from "./pages/audition";
import Member from "./pages/member";
import Memarea from "./pages/member/memarea";
import MConsult from "./pages/member/consult";
import MRecord from "./pages/member/record";
import MPoint from "./pages/member/point";
import MBook from "./pages/member/book";
import MAdd from "./pages/member/add";
import MExtend from "./pages/member/extend";
import MRecommend from "./pages/member/recommend";
import Memberlogin from "./pages/member/memberlogin";
import ResetPassword from "./pages/login/resetPassword";
import CpaQuiz from "./pages/cpaquiz";

//後台路由
import AdmH from "./pages/admh";
import AdmStaff from "./pages/admstaff";
import AdmTeacher from "./pages/admteacher";
import AdmTM from "./pages/admtm";
import AdmMember from "./pages/admmember";
import AdmQa from "./pages/admqa";
import AdmCrm from "./pages/admcrm";
import AdmProduct from "./pages/admproduct";
import AdmOrder from "./pages/admorder";
import AdmDiscount from "./pages/admdiscount";
import AdmPartner from "./pages/admpartner";
import AdmMemberView from "./pages/admmemberview";
import AdmMemberEdit from "./pages/admmemberedit";
import AdmReport from "./pages/admreport";
import AdmLogin from "./pages/admlogin";
import AdmNews from "./pages/admnews";
import AdmVideo from "./pages/admvideo";
import AdmShare from "./pages/admshare";
import AdmFiles from "./pages/admfiles";
import AdmMou from "./pages/admmou";
import AdmPoint from "./pages/admpoint";
import AdmBook from "./pages/admbook";
import AdmAdd from "./pages/admadd";
import AdmEve from "./pages/admeve";
import AdmExtend from "./pages/admextend";
import AdmRecommend from "./pages/admrecommend";
import AdmLog from "./pages/admlog";
import PartnerDashboard from "./pages/partner/PartnerDashboard";
import PartnerPrivateRoute from "./components/PartnerPrivateRoute";
// import OfferCountdownBanner from "./components/OfferCountdownBanner";
import GlobalCampaignBanner  from "./components/GlobalCampaignBanner";

function App() {
  return (
    <>
      <BrowserRouter>
        {/* <OfferCountdownBanner showDemoControls={false} /> */}
        <GlobalCampaignBanner/>
        <ScrollToTop behavior="instant" /* containerSelector=".main-content" */ />
        <AuthProvider>
          <PaymentProvider>
            <Routes>
              {/* 後台登入頁 (不受保護) */}
              <Route path="/adm/admlogin" element={<AdmLogin />} />
              <Route path="/adm/partner"
                element={
                  <PartnerPrivateRoute>
                    <PartnerDashboard />
                  </PartnerPrivateRoute>
                }
              />
              {/* 受保護的後台區塊 */}
              <Route path="/adm/*" element={<AdminPrivateRoute />}>
                  <Route index element={<Navigate to="/adm/admh" />} />
                  <Route path="admh" element={<AdmH />} />
                  <Route path="admstaff" element={<AdmStaff />} />
                  <Route path="admteacher" element={<AdmTeacher />} />
                  <Route path="admtm" element={<AdmTM />} />
                  <Route path="admmember" element={<AdmMember />} />
                  <Route path="admcrm" element={<AdmCrm />} />
                  <Route path="admqa" element={<AdmQa />} />
                  <Route path="admproduct" element={<AdmProduct />} />
                  <Route path="admorder" element={<AdmOrder />} />
                  <Route path="admdiscount" element={<AdmDiscount />} />
                  <Route path="admpartner" element={<AdmPartner />} />
                  <Route path="admmou" element={<AdmMou />} />
                  <Route path="admmemberview" element={<AdmMemberView />} />
                  <Route path="admmemberedit/:mem_id" element={<AdmMemberEdit />} />
                  <Route path="admreport" element={<AdmReport />} />
                  <Route path="admnews" element={<AdmNews />} />
                  <Route path="admvideo" element={<AdmVideo />} />
                  <Route path="admShare" element={<AdmShare />} />
                  <Route path="admpoint" element={<AdmPoint />} />
                  <Route path="admbook" element={<AdmBook />} />
                  <Route path="admadd" element={<AdmAdd />} />
                  <Route path="admeve" element={<AdmEve />} />
                  <Route path="admextend" element={<AdmExtend />} />
                  <Route path="admrecommend" element={<AdmRecommend />} />
                  <Route path="admlog" element={<AdmLog />} />
                  <Route path="admFiles/:user_type/:user_id/:tag_id" element={<AdmFiles />} />
              </Route>
              <Route
                path="/*"
                element={
                  <Layout>
                    <Routes>
                      <Route index element={<Home />} />
                      <Route path="/home/newdetail/:new_id" element={<Newdetail />}/>
                      <Route path="/about/*">
                        <Route index element={<Navigate to="/about/origin" />} />
                        <Route path="origin" element={<Origin />} />
                        <Route path="glory" element={<Glory />} />
                        <Route path="csr" element={<Csr />} />
                      </Route>
                      <Route path="/becker" element={<Becker />} />
                      <Route path="/quickbuy" element={<Quickbuy />} />
                      <Route path="/cpa" element={<Cpa />}/>
                      <Route path="/cia" element={<Cia />}/>
                      <Route path="/cpe" element={<Cpe />}/>
                      <Route path="/cma" element={<Cma />} />
                      <Route path="/ea" element={<Ea />} />
                      <Route path="/csu" element={<Csu />} />
                      <Route path="/registration" element={<Registration />} />
                      <Route path="/registration/plan" element={<Plan />} />
                      <Route path="/registration/payinfo" element={<Payinfo />} />
                      <Route path="/registration/pay" element={<Pay />} />
                      <Route path="/registration/success" element={<Success />} />
                      <Route path="/registration/failed" element={<Failed />} />
                      <Route path="/service" element={<Service />} />
                      <Route path="/share" element={<Share />} />
                      <Route path="/share/detail/:artId" element={<Detail />} />
                      <Route path="/video" element={<Video />} />
                      <Route path="/faq" element={<Faq />} />
                      <Route path="/audition" element={<Audition />} />
                      <Route path="/consult" element={<Consult />} />
                      <Route path="/consult/form" element={<Form />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/member" element={<Member />} />
                      <Route path="/member/memarea" element={<Memarea />} />
                      <Route path="/member/consult" element={<MConsult />} />
                      <Route path="/member/record" element={<MRecord />} />
                      <Route path="/member/recommend" element={<MRecommend />} />
                      <Route path="/member/point" element={<MPoint />} />
                      <Route path="/member/extend" element={<MExtend />} />
                      <Route path="/member/book" element={<MBook />} />
                      <Route path="/member/add" element={<MAdd />} />
                      <Route path="/member/memberlogin" element={<Memberlogin />} />
                      <Route path="/login/resetPassword" element={<ResetPassword />} />
                      <Route path="/cpaquiz" element={<CpaQuiz />} />
                    </Routes>
                  </Layout>
                }
              />
            </Routes>
          </PaymentProvider>
        </AuthProvider>  
      </BrowserRouter>
    </>
  );
}

export default App;